import axios from "axios";

export const adaUploader = onUploadProgress => (
  axios.create({
    baseURL: "https://uploads.ada.support",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    onUploadProgress
  })
);
